module.exports = __webpack_public_path__ + "img/img_02.0b6f2149.png";